export default {
  ratePlanType: {
    STANDARD: '스탠다드',
    BAR: '베스트 요금',
    CORPORATE: '기업',
    MEMBER: '멤버',
    PACKAGE: '패키지',
    PROMOTIONAL: '프로모션',
    OTA: 'OTA',
    WHOLESALE: '도매',
    NEGOTIATED: '협의 요금',
    MIXED: '혼합 요금',
  },
} as const;
